'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WishList = undefined;

var _WishList2 = require('./WishList');

var _WishList3 = _interopRequireDefault(_WishList2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.WishList = _WishList3.default; /**
                                        * Created by maximus on 16.12.16.
                                        */


//////////////////
// WEBPACK FOOTER
// ./src/containers/WishList/index.js
// module id = 1855
// module chunks = 0